<template>
  <div class="company-form">
    <form @submit.prevent="handleSubmit">
      <div v-if="editCompany">
        <h2 class="text-center">{{ "Edit Company - " + companySlug }}</h2>
      </div>
      <div v-else>
        <h2 class="text-center">Add Company</h2>
      </div>
      <section class="mb-10">
        <div class="w-full">
          <div class="w-full">
            <label for="company-name"
              >Name<span class="text-red">*</span></label
            >
            <input
              id="company-name"
              v-model="companyName"
              v-validate="'required'"
              type="text"
              placeholder="Add a Company Name"
              name="name"
            />
            <small class="err-msg text-red block mt-2">
              {{ veeValidateErrors.first("name") }}
            </small>
          </div>
        </div>
        <div class="mt-5 flex items-center">
          <label for="company-status">is Archived</label>
          <input
            id="company-status"
            v-model="isArchived"
            class="mb-0 ml-3"
            type="checkbox"
          />
        </div>
        <div class="mt-5">
          <div class="w-full">
            <label>Company Description <span class="text-red">*</span></label>
            <QuillEditor
              ref="myQuillEditor"
              v-model="companyDescription"
              :options="quillEditorOptions"
              style="height: 200px;"
            />
            <small class="err-msg text-red block mt-2">
              {{ veeValidateErrors.first("description") }}
            </small>
          </div>
        </div>
      </section>
      <div class="text-right p-4 mt-10 mr-10">
        <button
          type="submit"
          class="text-right bg-green hover:bg-green-dark px-4 py-2 text-white"
        >
          {{ editCompany ? "Update Company" : "Create Company" }}
        </button>
      </div>
    </form>
    <div v-if="editCompany" class="mt-10 mb-20">
      <h2 class="text-center">
        {{ "Assign Questions to this company :  " + companyId }}
      </h2>

      <div class="question-sticher">
        <label>Select Question Type</label>
        <div
          class="code-type-selector-container text-center text-xs flex items-center ml-20 my-8"
          style="width:5rem;"
        >
          <button
            class="hover:bg-grey rounded-sm m-4 flex flex-col text-grey-darker items-center justify-center py-1 px-4"
            :class="questionType == 6 ? 'selected-type' : ''"
            title="Code"
            @click="getQuestions(6)"
          >
            <i class="material-icons cursor-pointer">code</i>
            Code
          </button>
          <button
            class="hover:bg-grey rounded-sm m-4 flex flex-col text-grey-darker items-center justify-center py-1 px-4"
            :class="questionType == 9 ? 'selected-type' : ''"
            title="Web"
            @click="getQuestions(9)"
          >
            <i class="material-icons cursor-pointer ">web</i>
            Web
          </button>
          <button
            class="hover:bg-grey rounded-sm m-4 flex flex-col text-grey-darker items-center justify-center py-1 px-4"
            :class="questionType == 8 ? 'selected-type' : ''"
            title="Blockly"
            @click="getQuestions(8)"
          >
            <i class="material-icons cursor-pointer">casino</i>
            Blockly
          </button>
          <button
            class="hover:bg-grey rounded-sm m-4 flex flex-col text-grey-darker items-center justify-center py-1 px-4"
            :class="questionType == 0 ? 'selected-type' : ''"
            title="MCQ"
            @click="getQuestions(0)"
          >
            <i class="material-icons cursor-pointer">question_answer</i>
            MCQ
          </button>
        </div>
      </div>
      <div class="m-5 mt-10">
        <p>The total CODING questions are: {{ questionTypesCount.code }}</p>
        <p>The taotal MCQ questions are: {{ questionTypesCount.mcq }}</p>
      </div>
      <div class=" w-3/4">
        <label>Add Questions</label>
        <VueSelect
          v-model="selectedQuestions"
          multiple
          :closeOnSelect="false"
          label="name"
          :options="getQuestionOptions(questionOptions)"
        />
      </div>
      <div class="p-4 mt-10">
        <button
          class="text-right bg-green hover:bg-green-dark px-4 py-2 text-white"
          @click="assignQuestionsToTheCompany"
        >
          Assign Questions
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor"
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    VueSelect,
    QuillEditor: quillEditor,
  },
  data() {
    return {
      companyId: "",
      companyName: "",
      companyDescription: "",
      companyLogo: "",
      companySlug: "",
      isArchived: false,
      questionType: 6,
      questionOptions: [],
      selectedQuestions: [],
      test: 19,
      questionTypesCount: {
        mcq: 0,
        code: 0,
        web: 0,
        blockly: 0,
      },
      quillEditorOptions: {
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            ["blockquote", "code-block"],
            [{ indent: "-1" }, { indent: "+1" }],
            ["clean"],
          ],
        },
        placeholder: "Enter your comments here...",
        readOnly: false,
        theme: "snow",
      },
    }
  },
  computed: {
    editCompany() {
      return !!this.$route.params.id
    },
  },
  async created() {
    if (this.editCompany) {
      this.getCompany()
      this.fetchQuestions()
    }
  },
  methods: {
    getQuestions(type) {
      this.questionType = type
      this.fetchQuestions()
    },
    getQuestionOptions(options) {
      const questions = options.map((question) => {
        const elem = {}
        elem.id = question.id
        elem.name = question.name
        return elem
      })
      return questions
    },
    formatJobPayload() {
      const data = {}
      data.name = this.companyName
      data.is_archived = this.isArchived
      data.description = this.companyDescription
      data.logo = this.companyLogo
      return data
    },
    handleSubmit() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.$noty.error("Please fix the errors and try again")
          return
        }

        const payload = this.formatJobPayload()
        this.axios({
          method: this.editCompany ? "PUT" : "post",
          url: `${siteConfig.siteURL}admin/company${
            this.editCompany ? `/${this.$route.params.id}` : ""
          }`,
          data: payload,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
            "x-api-key": process.env.VUE_APP_API_KEY_SECRET_TOKEN,
          },
        }).then(() => {
          this.$router.push({ name: "CompanyList" })
          this.$noty.success("Successful", {
            layout: "bottomLeft",
            theme: "relax",
            timeout: 1000,
          })
        })
      })
    },
    getCompany() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/company/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then((res) => {
          const data = res.data.item
          this.companyId = data.id
          this.companyName = data.name
          this.companyDescription = data.description
          this.companySlug = data.slug
          this.companyLogo = data.logo
          this.isArchived = data.is_archived
          this.questionTypesCount.code = data.company_questions_count.code
          this.questionTypesCount.mcq = data.company_questions_count.mcq
        })
        .catch((error) => {
          this.$noty.error(`Failed to get the hints ${error}`)
        })
    },
    fetchQuestions() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/questions?pagination=false&search_by_type=${this.questionType}&fields=id,slug,name,reading_time,type,points,time_allocated,list`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then((res) => {
          this.questionOptions = res.data.items
        })
        .catch((error) => {
          this.$noty.error(`failed to fetch the questions ${error}`)
        })
    },
    assignQuestionsToTheCompany() {
      const data = {
        questions: this.selectedQuestions.map((c) => c.id),
      }
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/assign_questions/company/${this.companyId}`,
        data,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then((res) => {
          const data = res.data.data.company_questions_count
          this.questionTypesCount.code = data.code
          this.questionTypesCount.mcq = data.mcq
          this.$noty.success("Successful assigned questions to the company", {
            layout: "bottomLeft",
            theme: "relax",
            timeout: 1000,
          })
          this.selectedQuestions = []
        })
        .catch((error) => {
          this.$noty.error(`failed to assigned questions ${error}`)
        })
    },
  },
}
</script>

<style scoped>
.company-form {
  max-width: 900px;
  margin: auto;
}
.company-form label {
  display: block;
  padding: 10px 0px;
  font-size: 16px;
  text-align: left;
}
input[type="submit"] {
  width: 100%;
  margin-bottom: 10px;
}
.question-sticher label {
  font-weight: bold;
}
.code-type-selector-container .selected-type {
  border: 1px solid #b3b3b3;
  background: #0000001a;
}
.code-type-selector-container {
  overflow: visible;
  position: sticky;
}
</style>
